/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import './global-error.scss';

const GlobalError = ({
  children,
}) => (
  <div className="global-error-box c-utility-red m-t-40 m-b-40 d-none">
    {children}
    {!children && (
    <>
      <p className="ff-graphik tt-upper fs-p2 fw-medium c-utility-red">You caught us sleeping</p>
      <div className="ff-graphik fw-normal fs-p2">
        We're running into a technical issue. Try again in a few minutes or contact customer service for immediate assistance at&nbsp;
        <a className="pointer c-utility-red" href="tel:+18888488456">1-888-848-8456</a>
      </div>
    </>
    )}
  </div>
);

export default GlobalError;
